import React from 'react';
import { Navbar } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import './Header.css'

const Header = () => {
    return (

        <div>
            {/* This is Header section */}
            <Navbar bg="dark" variant="dark" className="p-3">

                <div className="ms-3">
                    <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTcHEve6OWGPPvkw_HLID8HlKgsQ_sPiOBA4Q&usqp=CAU" width="30" height="30" alt="" />

                    <NavLink className="ms-3 nav-button" activeStyle={{
                        backgroundColor: "gray"
                    }} to="/home" >Home</NavLink>
                    <NavLink className="nav-button" activeStyle={{
                        backgroundColor: "gray"
                    }} to="/courses">Courses</NavLink>
                    <NavLink className="nav-button" activeStyle={{
                        backgroundColor: "gray"
                    }} to="/about">About</NavLink>
                    <NavLink className="nav-button" activeStyle={{
                        backgroundColor: "gray"
                    }} to="/login">Log In</NavLink>
                </div>

            </Navbar>
        </div>

    );
};

export default Header;